import React from 'react'
import { connect } from 'react-redux'
import { Row, Button } from 'reactstrap'
import { Link } from 'react-router-dom'
import useFetchingEmailReports from './useFetchingEmailReports'
import EmailReportTable from './EmailReportTable'
import LoadingSpinner from '../Shared/LoadingSpinner'
import PageContainer from '../Shared/LayoutComponents/PageContainer'
import PageHeading from '../Shared/LayoutComponents/PageHeading'

const Companies = (props) => {
  useFetchingEmailReports()

  if (props.loading) {
    return <LoadingSpinner />
  } else {
    return (
      <PageContainer>
        <div className="float-right">
          <Link to="/EmailReport/Create">
            <Button color="primary" >
              Create New
            </Button>
          </Link>
        </div>
        <Row>
          <PageHeading>
            Email Reports
          </PageHeading>
        </Row>
        <EmailReportTable style={{ paddingTop: '25px'}} companies={props.emailReportList} />
      </PageContainer>
    )
  }
}

const mapStateToProps = (state) => ({
  loading: state.emailReports.loading,
  emailReportList: state.emailReports.emailReportList,
})

const mapDispatchToProps = {}

export default connect(mapStateToProps, mapDispatchToProps)(Companies)
